import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { DateTimeFormatterPipe } from '@trademe/tangram';
import { Subject } from 'rxjs';
import { StepIds } from '../../../models/property-step/property-step-model';
import { ListingDurationService } from '../../../services/listing-duration.service';
import { DraftFacade } from '@classifieds-sell/state';
import { PropertySectionBase } from '../../property-section-base';

@Component({
    selector: 'property-summary-page-rental-details-section',
    templateUrl: './summary-page-rental-details-section.component.html',
    styleUrls: ['./summary-page-rental-details-section.component.scss']
})
export class SummaryPageRentalDetailsSectionComponent
    extends PropertySectionBase
    implements OnInit, OnDestroy {
    stepIds = StepIds;

    rentPerWeek: number;
    availableFrom: Date;
    maximumTenants: string;
    petsOK: string;
    smokersOK: string;
    smokeAlarms: string;
    mobile: string;
    landLine: string;
    bestContactTime: string;
    registeredPropertyAgent: string;
    isPropertyAgent: boolean;
    name: string;
    agency: string;
    isRentiAccepted: string;
    endDate: string;

    private _destroyed$: Subject<void> = new Subject<void>();

    constructor(
        draftFacade: DraftFacade,
        private _dateTimeFormatterPipe: DateTimeFormatterPipe,
        private _changeDetectorRef: ChangeDetectorRef,
        private _listingDurationService: ListingDurationService
    ) {
        super(draftFacade);
    }

    ngOnDestroy(): void {
        super.onDestroy();
        this._destroyed$.next();
    }

    ngOnInit(): void {
        super.onInit(() => {
            this.rentPerWeek = this.draftData.propertyInformation.pricePerWeek.toLocaleString();
            this.availableFrom = new Date(
                this.draftData.propertyInformation.availableFrom
            );
            this.maximumTenants = this.metadata.maxTenants.find(
                (f) => f.value === this.draftData.propertyDescription.maxTenants
            ).display;
            this.petsOK = this.metadata.pets.find(
                (f) => f.value === this.draftData.propertyDescription.pets
            ).display;
            this.smokersOK = this.metadata.smokers.find(
                (f) => f.value === this.draftData.propertyDescription.smokers
            ).display;
            this.mobile = this.draftData.propertyInformation.mobile;
            this.landLine = this.draftData.propertyInformation.landLine;
            this.bestContactTime = this.metadata.contactTimes.find(
                (f) =>
                    f.value === this.draftData.propertyInformation.contactTimes
            ).display;
            this.registeredPropertyAgent = this.draftData.propertyInformation
                .isPropertyAgent
                ? 'Yes'
                : 'No';
            if(this.draftData.propertyInformation.duration){
                const futureDate = this._listingDurationService
                    .availableDateText(this.metadata, this.draftData.propertyInformation.duration);
                this.endDate = this._dateTimeFormatterPipe.transform(
                    futureDate,
                    { format: 'short' }
                );
            }else{
                this.endDate = this._dateTimeFormatterPipe.transform(
                    this.metadata.listingEndDate,
                    { format: 'short' }
                );
            }
            this.isRentiAccepted = this.draftData.propertyInformation
                .isRentiAccepted
                ? 'Yes'
                : 'No';
            this.isPropertyAgent = this.draftData.propertyInformation.isPropertyAgent;
            this.name = this.draftData.propertyInformation.name;
            this.agency = this.draftData.propertyInformation.agency;
            this._changeDetectorRef.markForCheck();
        });
    }

    isValid(): boolean {
        return true;
    }

    dirty(): boolean {
        return false;
    }

}
